export const PRODUCT_NAME = Object.freeze("Spectra Analyze");
export const PAGE_TITLE_SEPARATOR = Object.freeze(" - ");
export const PAGE_TITLE_PREFIX = Object.freeze(
  `${PRODUCT_NAME}${PAGE_TITLE_SEPARATOR}`
);
export const ADMINISTRATION_PAGE_TITLE_PREFIX = Object.freeze(
  `${PAGE_TITLE_PREFIX}Administration${PAGE_TITLE_SEPARATOR}`
);

export const PAGE_TITLE = Object.freeze({
  ALERTS: `${PAGE_TITLE_PREFIX}Alerts`,
  ALERT_CONFIG: `${PAGE_TITLE_PREFIX}Configure Alert`,
  DASHBOARD: `${PAGE_TITLE_PREFIX}Dashboard`,
  SAMPLE_DETAILS: (filename?: string) =>
    filename
      ? `${PAGE_TITLE_PREFIX}${filename} details`
      : `${PAGE_TITLE_PREFIX}Sample details`,
  SAMPLE_DETAILS_CLOUD: (filename?: string) =>
    filename
      ? `${PAGE_TITLE_PREFIX}${filename} details`
      : `${PAGE_TITLE_PREFIX}Sample cloud details`,
  SEARCH: `${PAGE_TITLE_PREFIX}Search`,
  USER: `${PAGE_TITLE_PREFIX}User settings`,
  CLUSTER: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Redundancy system`,
  CONNECTORS: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Connectors`,
  INTEGRATIONS: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Integrations configuration`,
  ROLES: `${ADMINISTRATION_PAGE_TITLE_PREFIX}User roles`,
  STATUS: `${ADMINISTRATION_PAGE_TITLE_PREFIX}System status`,
  LOGIN: `${PAGE_TITLE_PREFIX}Login`,
  RESET_PASSWORD: `${PAGE_TITLE_PREFIX}Reset password`,
  YARA: `${PAGE_TITLE_PREFIX}YARA`,
  NOT_FOUND: `${PAGE_TITLE_PREFIX}Page not found`,
  ERROR: (message?: string) => `${PAGE_TITLE_PREFIX}${message ?? "Error"}`,
  LICENSING: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Licensing`,
  LICENSE_EXPIRED: `${PAGE_TITLE_PREFIX}License expired`,
  QUOTA_USAGE_ALERTS: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Quota Usage Alerts`,
  PARANOID_MODE: `${ADMINISTRATION_PAGE_TITLE_PREFIX}Risk Tolerance Levels`,
  URL: (url: string) => `${PAGE_TITLE_PREFIX}${url} details`,
  DOMAIN: (domain: string) => `${PAGE_TITLE_PREFIX}${domain} details`,
  IP: (ip: string) => `${PAGE_TITLE_PREFIX}${ip} details`,
  YARA_RULESET_DETAILS: (rulesetName?: string) =>
    `${PAGE_TITLE_PREFIX} ${rulesetName ?? "--"}`,
  YARA_TESTRUN: (rulesetName?: string) =>
    `${PAGE_TITLE_PREFIX} Test ${rulesetName ?? "--"}`,
  YARA_RULESET_EDIT: (rulesetName?: string) =>
    `${PAGE_TITLE_PREFIX} Edit ${rulesetName ?? "--"}`,
  YARA_REPOSITORIES: `${PAGE_TITLE_PREFIX}YARA Repositories`,
  NTI: (uri?: string) => `${PAGE_TITLE_PREFIX}${uri ?? "--"}`,
  IMPORT: `${PAGE_TITLE_PREFIX}Import`,
  INTERACTIVE_ANALYSIS: (hash?: string) =>
    `Spectra Analyze - Interactive Analysis for ${hash ?? "--"}`,
  GRAPH_MANAGER: `${PAGE_TITLE_PREFIX}Graph Manager`,
  GRAPH_EXPLORER: (graphName: string) =>
    `${PAGE_TITLE_PREFIX}${graphName || "Create Graph"}`,
  FLEXIBLE_INTEL_FEED: "Flexible Intel Feed"
});
